<template>
    <div v-if="!hide"  class="form-network form-network-facebook">
        <details open>
            <summary>Visibilité <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="list-simple-btn">
                    <div class="type-btn-simple" @click="addMode('addPlaceMode')">
                        <i class="fa-solid fa-map-pin"></i>
                        <p>Lieu <span class="pink">({{ formData.formDataNetwork.facebook.place ? '1' : '0' }})</span></p>
                
                    </div>    
                </div>         
            </div>      
        </details>
        <details v-if="formData && formData.urlsTextContentHistory && formData.urlsTextContentHistory.size">
            <summary>Modifier l’aperçu du lien <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="list-thubmmail">
             

                    <div class="thubmmail" v-for="(url) in this.formData.urlsTextContentHistory" @click="()=>selectUrl(url)" :key="url">
                        <Checkbox :id="url" :prefixId="'thubmmail-'" 
                            :isChecked="(formDataFacebook.snippet.link == url)" 
                            :isDisable="(formDataFacebook.snippet.link == url)"
                            :add="selectUrl" :remove="()=>{}">
                        </Checkbox>
                        <SnippetNetwork 
                            :link="url"
                            :imageUrlDefault="formDataFacebook.snippet.imageUrl ? formDataFacebook.snippet.imageUrl : undefined" 
                            :titleDefault="formDataFacebook.snippet.title ? formDataFacebook.snippet.title : undefined" 
                            :descriptionDefault="formDataFacebook.snippet.description ? formDataFacebook.snippet.description : undefined">
                        </SnippetNetwork>
                    </div>
                </div>
                <!-- <div class="type-switch">
                    Apporter des modifications à l'aperçu du lien
                    <ComponentSwitch :value="inputModel.switchCustomSnippet" :onChange="(v)=> inputModel.switchCustomSnippet = v" :id="'switch-settings-advanced-facebook-2'"></ComponentSwitch>
                </div>
            
                <template v-if="inputModel.switchCustomSnippet">
                    <div class="type-btn-add">
                        <i class="fa-solid fa-image" @click="()=> formDataFacebook.snippet.imageUrl = '' "></i>
                        Ajouter une image
                        <i class="fa-solid fa-plus" @click="()=> formDataFacebook.snippet.imageUrl ='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4Xuh673slO7MDTuB8cYoOSpnbSUc7OyKwrA&s'"></i>
                    </div>
                    <div class="type-input">
                        <i class="fa-solid fa-pen-to-square"></i>
                        <input placeholder="Titre par default" v-model="formDataFacebook.snippet.title">
                        <i class="fa-regular fa-square-minus" v-if="formDataFacebook.snippet.title" @click="()=> formDataFacebook.snippet.title =''"></i>
                    </div>
                    <div class="type-input">
                        <i class="fa-solid fa-pen-to-square"></i>
                        <input placeholder="Description par default" v-model="formDataFacebook.snippet.description">
                        <i class="fa-regular fa-square-minus" v-if="formDataFacebook.snippet.title" @click="()=> formDataFacebook.snippet.description =''"></i>
                    </div>
                </template> -->
            </div>
            
        </details>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import store from './../../../../store/index.js';
    import ComponentSwitch from '../../utils/switch.vue'
    import SnippetNetwork from './../SnippetNetwork.vue'
    import minxinBot from '../../../mixins/Bots.vue'
    import minxinPost from '../../../mixins/Posts.vue'
    import Checkbox from '../../utils/checkbox.vue'

    import {formatFileAcceptedByNetwork} from '../constante.js'
    export default {

        components: {
            ComponentSwitch,
            SnippetNetwork,
            Checkbox
        },
        mixins: [minxinBot,minxinPost],

        props: {
            hide : {
                type: Boolean,
                default: false
            },
            formData: {
                type: Object,
                default: () => ({})
            },
            formDataFacebook: {
                type: Object,
                default: () => ({})
            },
            files:Object
           
        },
        
        data() {
            return {
                inputModel:{
                    switchCustomSnippet: false,
                    urlImageSnippet: "",
                    titleSnippet: "",
                    descriptionSnippet: "",
                },

                lastModeSelected : undefined
            }
        },

        created () {

        },

        mounted() {
            if (this.formData.formDataNetwork.facebook) this.formDataFacebook = this.formData.formDataNetwork.facebook

            EventBus.$on('eventSearchFromSelectPlace', this.searchPlace);
            EventBus.$on('eventClickSelectPlace', this.addPlace);
            EventBus.$on('eventRemoveSelectPlace', this.removePlace);
        },

        methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },

            selectUrl(url) {
                
                if (!this.formDataFacebook.snippet) this.formDataFacebook.snippet = {}
                this.formDataFacebook.snippet.link = this.formDataFacebook.snippet.link == url ? '' : url
                this.$emit('setFormDataNetwork', 'facebook', this.formDataFacebook)
            },

            verifUrlSelected() {
                if (this.formData.urlsTextContentHistory.size) {
                    let linkSelect = this.formDataFacebook && this.formDataFacebook.snippet && this.formDataFacebook.snippet.link ? this.formDataFacebook.snippet.link : null
                    if ((linkSelect && !this.formData.urlsTextContentHistory.has(linkSelect))) {
                        this.selectUrl('')
                    }
                }else{
                    this.selectUrl('')
                }
             
            },
            
            detectTypeMedia() {
                console.log("detectTypeMedia facebook", this.formData.files.length)
                if(this.formData.files.length) {
                    try {
                        this.formDataFacebook.typeMedia = this.files[this.formData.files.find(f => ['video','image'].includes(this.files[f.id].info.type2)).id].info.type2
                        this.$emit('setFormDataNetwork', 'facebook', this.formDataFacebook)
                    } catch (error) {
                        console.error("impossible de detecter le type media sur formulaire facebook")
                    }
                }
            },

            async searchPlace(network, value,idEvent) {
                console.log("searchPlace facebook")
                if (network !== 'facebook') return
                let page = this.pagesSelected.find(p => p.network == "facebook" && p.bot_status)
                
                let result = []
                if (page) {
                    result = (await this.getLocation(page.id, value)).body.locations
                }
                EventBus.$emit("resultSearchFromSelectPlace", result, idEvent)
            },

            addPlace(network, place) {
                if (network !== 'facebook') return
                this.formDataFacebook.place = place
                this.$emit('setFormDataNetwork', 'facebook', this.formDataFacebook)
            },

            removePlace(network) {
                if (network !== 'facebook') return
                this.formDataFacebook.place = undefined
                this.$emit('setFormDataNetwork', 'facebook', this.formDataFacebook)
            },
            
          
        },


       

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'];
            },
        },

        watch: {
            ['formData.formDataNetwork.facebook']() {
                if (this.formData.formDataNetwork.facebook) this.formDataFacebook = this.formData.formDataNetwork.facebook
            },
            'formData.urlsTextContentHistory'(newValue) {
                this.verifUrlSelected()
            },
            'formData.files'(newValue) {
                
                this.detectTypeMedia()
            }, 
            'inputModel.switchCustomSnippet' (newValue) {
                if(!newValue) {
                    this.formDataFacebook.snippet.imageUrl = ''
                    this.formDataFacebook.snippet.title = ''
                    this.formDataFacebook.snippet.description = ''
                }
            }
        },


        beforeDestroy () {
            EventBus.$off('eventSearchFromSelectPlace', this.searchPlace);
            EventBus.$off('eventClickSelectPlace', this.addPlace);
            EventBus.$off('eventRemoveSelectPlace', this.removePlace);
        }
        
    }
</script>